import styled from '@emotion/styled';
import { media } from '@utex/ui-kit';

export const Container = styled('div')`
  width: 32rem;
  margin-top: 1rem;
  padding: 2.1rem;
  border-radius: 1.4rem;
  background: linear-gradient(151.96deg, #b2b8c2 -10.61%, #737d89 105.18%);

  @media ${media.phonablet} {
    width: 100%;
    max-width: 34.3rem;
  }
`;

export const IconWrapper = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
`;

export const Icon = styled('img')`
  & + & {
    margin-left: 1.8rem;
  }
`;

export const InputBg = styled('div')`
  border-radius: 0.8rem;
  background-color: #fff;

  & + & {
    margin-top: 1rem;
  }
`;
